"use strict";
export default function () {
    const header = document.querySelector(".o-header.o-header-desk");
    const menu_qm = document.querySelector(".menu-quem-somos__container");

    if (header) {
        let lastScrollTop = 0;
        window.addEventListener("scroll", function () {
            const scrollTop = window.pageYOffset;
            // Verifica a direção do scroll
            if (scrollTop >= 1) {
                header.classList.remove("o-header__animation");
            }

            if (scrollTop >= 200) {
                if (
                    scrollTop > lastScrollTop &&
                    !header.classList.contains("hide-header")
                ) {
                    // Se estiver rolando para baixo, oculta o header

                    header.classList.add("hide-header");
                    if (menu_qm) menu_qm.classList.add("hide-header");
                } else if (
                    scrollTop < lastScrollTop &&
                    header.classList.contains("hide-header")
                ) {
                    // Se estiver rolando para cima, mostra o header
                    header.classList.remove("hide-header");
                    if (menu_qm) menu_qm.classList.remove("hide-header");
                }
            } else if (scrollTop < 200) {
                header.classList.remove("hide-header");
            }

            if (scrollTop === 0) {
                header.classList.add("o-header__animation");
                header.classList.remove("hide-header");
                if (menu_qm) menu_qm.classList.remove("hide-header");
            }
            // Atualiza a última posição de rolagem
            lastScrollTop = scrollTop;
        });
    }

    const header_mobile = document.querySelector(".o-header.o-header-mobile");
    if (header_mobile) {
        let startY;

        window.addEventListener("touchstart", function (e) {
            startY = e.touches[0].clientY;
        });

        window.addEventListener("touchmove", function (e) {
            if (!startY) return; // Verifica se startY foi inicializado
            const scrollTop = window.pageYOffset;

            const currentY = e.touches[0].clientY;
            const deltaY = currentY - startY; // Calcula a diferença entre a posição atual e a posição inicial

            if (scrollTop === 0) {
                header_mobile.classList.remove("hide-header");
            } else if (scrollTop >= 200) {
                if (deltaY < 0) {
                    // Se a diferença for maior que -50 (indicando um movimento para cima)
                    header_mobile.classList.add("hide-header");
                    if (menu_qm) menu_qm.classList.add("hide-header");
                } else if (deltaY > 0) {
                    // Se a diferença for maior que 50 (indicando um movimento para baixo)
                    header_mobile.classList.remove("hide-header");
                    if (menu_qm) menu_qm.classList.remove("hide-header");
                }
            }
        });

        window.addEventListener("touchend", function () {
            startY = 0; // Reinicializa startY quando o toque termina
        });
    }
}
